<div>
    <div class="img-container">
        <img src="/onboard/assets/images/banner/wifi-access.jpg" alt="WiFi Access">
        <div class="overlay">
          <div class="overlay-text"><h3>Enjoy high-speed wifi in the sky</h3></div>
        </div>
      </div>
    <div class="accordion">
      <!-- First Accordion Start -->
      <div class="accordion-section top-border">
        <a class="accordion-section-title acc-head" (click)="toggleAccordion('accordion1')" [ngClass]="{'active': activeAccordion === 'accordion1'}">
            
          WiFi access<span class="arrow"></span>
        </a>
        <div id="accordion1" class="accordion-section-content" [ngClass]="{'active': activeAccordion === 'accordion1'}">
          <div class="text parbase">
            <h4 class="pad-b-5">Free WiFi access</h4>
            <span>Free WiFi for one device during the entire flight</span>
            <ul style="list-style-position: none">
              <li><img src="https://www.flysas.com/v2/de-design-library/assets/icons/raw/cl--check-circle?color=30a030"> EuroBonus Diamond</li>
              <li><img src="https://www.flysas.com/v2/de-design-library/assets/icons/raw/cl--check-circle?color=30a030"> EuroBonus Gold</li>
              <li><img src="https://www.flysas.com/v2/de-design-library/assets/icons/raw/cl--check-circle?color=30a030"> SAS Business</li>
            </ul>
            <h4 class="mrgn-t-10 pad-b-5">BUY WIFI ACCESS</h4>
            <span>Pay per connected device for the whole flight time</span>
          </div>
        </div>
      </div>
      <!-- First Accordion End -->

      <!-- Second Accordion Start -->
      <div class="accordion-section">
        <a class="accordion-section-title acc-head" (click)="toggleAccordion('accordion2')" [ngClass]="{'active': activeAccordion === 'accordion2'}">
          Connect more devices<span class="arrow"></span>
        </a>
        <div id="accordion2" class="accordion-section-content" [ngClass]="{'active': activeAccordion === 'accordion2'}">
          <div class="text parbase">
            <ul class="list-sy">
                <li>Select <b>SASWIFI</b> on your device</li>
                <li>Open a browser and enter <b>sas.viasat.com</b></li>
                <li>Enter your name and booking reference</li>
                </ul>
                <span class="mrgn-top-20">You can switch between devices using the same name and booking reference.</span>
                <span>To enjoy WiFi on more than 1 device, just buy access for more devices.</span>
          </div>
        </div>
      </div>
      <!-- Second Accordion End -->           
    </div>
  </div>